import { cn } from "@/utils/utils";
import React from "react";

const TagFilledIcon = ({ className }: { className?: string }) => {
  return (
    <span className={cn("block w-6 h-6 text-red-500", className)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={"100%"}
        height={"100%"}
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.29289 6.29289C3 6.58579 3 7.05719 3 8V16C3 16.9428 3 17.4142 3.29289 17.7071C3.58579 18 4.05719 18 5 18H14.3344C15.4019 18 15.9357 18 16.3835 17.7557C16.8313 17.5114 17.1201 17.0626 17.6979 16.1649L18.9852 14.1649C19.6619 13.1137 20.0002 12.588 20.0002 12C20.0002 11.412 19.6619 10.8863 18.9852 9.83507L17.6979 7.83507C17.1201 6.93743 16.8313 6.48861 16.3835 6.24431C15.9357 6 15.4019 6 14.3344 6H5C4.05719 6 3.58579 6 3.29289 6.29289ZM14.5848 13.9995C15.6513 13.9995 16.5158 13.1041 16.5158 11.9995C16.5158 10.8949 15.6513 9.99951 14.5848 9.99951C13.5184 9.99951 12.6539 10.8949 12.6539 11.9995C12.6539 13.1041 13.5184 13.9995 14.5848 13.9995Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

export default TagFilledIcon;
